import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import MobileLayout from "../components/mobile-layout"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Spinner from 'react-bootstrap/Spinner'
import Image from "../components/image"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"

const isBrowser = () => typeof window !== "undefined"
const isMobile = isBrowser() ? (window.innerWidth < 980 ? true : false) :  false

const NotFoundPage = () => {

	const [width, setWidth] = useState(0)

	useEffect(() => {
		if (isBrowser()) {
			setWidth(window.innerWidth);
			const handleResize = () => setWidth(window.innerWidth)
			window.addEventListener("resize", handleResize);
			return () => {
				window.removeEventListener("resize", handleResize);
			};
		}
	}, []);

	if (isBrowser()) {
		if (width !== 0) {
			if (isMobile || width <= 980) {
				return (
					<MobileLayout>
						<SEO title="Leanpitch | 404: Not found" />
						<Row className="mx-auto w-100 my-3">
							<Col xs="12" sm="6" md="6" className="center mb-3">
								<Image src={'webnos.png'} imgStyle={{ objectFit: `contain` }} type={`fluid`}/>
							</Col>
							<Col xs="12" sm="8" md="6" className="center text-center">
								<h1 className="col-12 font-weight-bold" style={{fontSize: '3rem', color: 'rgb(0, 97, 197)'}}>Webnos</h1>
								<h4 className="col-12" style={{fontSize: '2rem', color: 'rgb(0, 97, 197)'}}>has wiped off 50% pages from the world</h4>
								<h6 className="col-12" style={{color: 'rgb(59, 59, 59)'}}> We have saved a few pages especially for you. Please take a look! </h6>
							</Col>
							<Col xs="12" sm="8" md="6" className="center px-4">
								<Link to="/" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '20px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-11 px-0">Our Trainings</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/videos" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '20px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-11 px-0">Videos</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/blogs" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '20px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-11 px-0">Blogs</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/about-us" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '20px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-11 px-0">About Us</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
							</Col>
						</Row>
					</MobileLayout>
				)
			} else {
				return (
					<Layout>
						<SEO title="Leanpitch | 404: Not found" />
						<Row className="mx-auto w-100 my-3">
							<Col lg="6" sm="12" md="6" className="center mb-3">
								<Image src={'webnos.png'} imgStyle={{ objectFit: `contain` }} type={`fluid`}/>
							</Col>
							<Col lg="6" sm="12" md="9" className="center text-center">
								<h1 className="col-12 font-weight-bold" style={{fontSize: '3rem', color: 'rgb(0, 97, 197)'}}>Webnos</h1>
								<h4 className="col-12" style={{fontSize: '2rem', color: 'rgb(0, 97, 197)'}}>has wiped off 50% pages from the world</h4>
								<h6 className="col-12" style={{color: 'rgb(59, 59, 59)'}}> We have saved a few pages especially for you. Please take a look! </h6>
							</Col>
							<Col lg="6" sm="12" md="9" className="center px-4">
								<Link to="/" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '21px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-12 px-0" style={{maxWidth: 'calc(100% - 1rem)'}}>Our Trainings</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/videos" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '21px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-12 px-0" style={{maxWidth: 'calc(100% - 1rem)'}}>Videos</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/blogs" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '21px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-12 px-0" style={{maxWidth: 'calc(100% - 1rem)'}}>Blogs</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
								<Link to="/about-us" className="col-12 float-left px-4 py-2 mt-2 text-white d-flex align-items-center" style={{borderRadius: '21px', backgroundColor: 'rgb(49, 159, 203)'}}><div className="col-12 px-0" style={{maxWidth: 'calc(100% - 1rem)'}}>About Us</div><div><FontAwesomeIcon icon={faArrowRight}/></div></Link>
							</Col>
						</Row>
					</Layout>
				)
			}
		} else {
			return (
				<>
					<SEO title="Leanpitch | 404: Not found" />
					<Col xs="12" sm="8" md="6" className="center text-center d-none">
						<h1 className="col-12 font-weight-bold" style={{fontSize: '3rem', color: 'rgb(0, 97, 197)'}}>Webnos</h1>
						<h4 className="col-12" style={{fontSize: '2rem', color: 'rgb(0, 97, 197)'}}>has wiped off 50% pages from the world</h4>
						<h6 className="col-12" style={{color: 'rgb(59, 59, 59)'}}> We have saved a few pages especially for you. Please take a look! </h6>
					</Col>
				</>
			)
		}
	} else {
		return null
	}
}

export default NotFoundPage
